export default __webpack_public_path__ + "static/media/line-h-08.ab52045f.png";